import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-apcn-range',
  templateUrl: './apcn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class APCNRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
